import { connect } from 'react-redux';
import InvoicePayment from '../../../../views/Finance/Spp/LaporanKeu/InvoicePayment.laporankeu.view';
import { getAdjustmentJournal } from '../../../../states/thunks/finance.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAdjustmentJournal: payload => dispatch(getAdjustmentJournal(payload)),
  };
}

export default connect(null, mapDispatchToProps)(InvoicePayment);
